import type { FaireProductEntity } from "../../entity_types/product";

export const p_huzvhcwact: FaireProductEntity = {
  token: "p_huzvhcwact",
  type: "product",
  name: '"New York in Sketches" Silk Scarf - Black & White',
  brandToken: "b_tsyrm2cvwb",
  brandName: "Lost Pattern NYC",
  imageUrl:
    "https://cdn.faire.com/fastly/cb3ff202e2212cc49aafca39f27914ec8b50e6ed524c8c7a424a4864d939af37.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67c5df3ed548f94a03b25e36de036fb257b4051d94125902fdc3119ae0007144.jpeg",
    "https://cdn.faire.com/fastly/5f91e9cd14046f43db99ad00ac0bea1b769c30972399b7691fa6dbf79ea25c06.jpeg",
    "https://cdn.faire.com/fastly/9bbdad3b61e93915a39cb36720397cc22b4bf82770711bfe45eaeeaea07a5934.jpeg",
    "https://cdn.faire.com/fastly/57d681e8329bee49cd27323051ce2dc72458115bdaaf7382134c8f087f9c21f1.jpeg",
    "https://cdn.faire.com/fastly/6a6b87b79e518da0678480deebe3c9effddf6c981fdfa41b22aac0a074821793.jpeg",
    "https://cdn.faire.com/fastly/efaaf1a6f1921d86ff3f06ad4eb8fa3eb0ce21c7ff6ed3950fcd5223d1633d24.jpeg",
    "https://cdn.faire.com/fastly/16d2bdf62019d20aeefb5dd64208b80a02530992c342749821089fdc0d54b838.jpeg",
    "https://cdn.faire.com/fastly/0a10075e0f958b70dd7b5cf7b765b44bf22ea2c801773234518cd1de1268c180.jpeg",
    "https://cdn.faire.com/fastly/a0a5b374b4ef1e6462ee3ad59f7376d50caf76fbab10caad8f0b4efd49404f4d.jpeg",
    "https://cdn.faire.com/fastly/4647e348000c20b0400f5eaead3602e96f46ec66f90444b5bdf77d710d4c9a09.jpeg",
    "https://cdn.faire.com/fastly/72ecd0489a81afbcd97f08726097816304bb67de7f4808bfcb73ef54bb2904c1.jpeg",
    "https://cdn.faire.com/fastly/1cb93b30ba5594f7d54707fc67b30ea4f216b9ca88f2894ec9be25ce27a37371.png",
  ],
  priceDollars: 42.5,
  description:
    'Meet "New York in Sketches" Silk Scarf\n\nThis silk scarf is designed by our chief designer Cata to give you a glimpse into our New York City memories and culture. Itis an ode to the city we love, and an excellent addition to your wardrobe.The scarf edges are hand-rolled and hand stitched by our local artisans to honor traditional silk making. The tag is designed to be recycled as a coaster to show our commitment to sustainability in Fashion.\n\n"New York in Sketches" Silk ScarfFeaturing: \n\n * Material: 100% mulberry silk \n * Size: 62cm x 62cm ( 24"W x 24"L ) \n * Craftsmanship: Edges are hand-rolled and hand stitched by local artisans \n*Due to the handmade nature of the edges, the measurement may vary slightly.\n\nHow to Wear A Silk Scarf:\n\n * As a silk hair scarf: tie it to hair or use it as a silk scarf for braids. \n * As a silk neck scarf: wear it around the neck - tie a bow or let the end hang loose. \n * As a silk head scarf/bandana:tied around as a headband or as a head wrap. \n * As a silk scarf for bag: tie to the handle of your favorite bag for a classic look. \n * Style it any way you want in your own mood and creativity! ',
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:47.939Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
